import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Jobs from '../views/Jobs.vue'
import Badges from '../views/Badges.vue'
import Users from '../views/Users.vue'
import Tags from '../views/Tags.vue'
import BlogNoSidebar from '../views/BlogNoSidebar.vue'
import BlogLeftSidebar from '../views/BlogLeftSidebar.vue'
import BlogRightSidebar from '../views/BlogRightSidebar.vue'
import BlogDetails from '../views/BlogDetails.vue'
import QuestionSingle from '../views/QuestionSingle.vue'
import About from '../views/About.vue'
import Contact from '../views/Contact.vue'
import UserProfile from '../views/UserProfile.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import FAQ from '../views/FAQ.vue'
import PageNotFound from '../views/PageNotFound.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/question-single/:question_id',
    name: 'question-single',
    component: QuestionSingle
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: Jobs
  },
  {
    path: '/badges',
    name: 'Badges',
    component: Badges
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/tags',
    name: 'Tags',
    component: Tags
  },
  {
    path: '/about-us',
    name: 'About',
    component: About
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/user-profile',
    name: 'UserProfile',
    component: UserProfile
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ
  },
  {
    path: '/page-not-found',
    name: 'PageNotFound',
    component: PageNotFound
  },
  {
    path: '/blog-no-sidebar',
    name: 'BlogNoSidebar',
    component: BlogNoSidebar
  },
  {
    path: '/blog-left-sidebar',
    name: 'BlogLeftSidebar',
    component: BlogLeftSidebar
  },
  {
    path: '/blog-right-sidebar',
    name: 'BlogRightSidebar',
    component: BlogRightSidebar
  },
  {
    path: '/blog-details',
    name: 'BlogDetails',
    component: BlogDetails
  }
]

const router = createRouter({
	history: createWebHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        left: 0,
        top: 0
      }
    }
  }
})

export default router
